export function getUserInitials(firstName: string, lastName: string): string {
  const first = firstName?.trim() ?? '';
  const last = lastName?.trim() ?? '';

  if (first && last) {
    return `${first[0]}${last[0]}`.toUpperCase();
  }

  const name = first || last;
  return name.slice(0, 2).toUpperCase();
}
